<template>
  <div class="tap_search">
    <div class="search-title">
      <div>
        <i class="el-icon-search"></i>
        筛选搜索
      </div>
      <div v-if="searchMoreShow" style="margin-right: 10px">
        <el-button type="text" @click="highSearch">
          {{ searchHightText }} <i :class="searchHightIcon"></i>
        </el-button>
      </div>
    </div>
    <ul class="search-form" style="height: 46px">
      <li
        v-for="(item, key, index) in searchList"
        v-show="item.hide !== true"
        :key="index"
        :style="item.styleLi"
        :class="{ DateTimePicker: item.type == 'DateTimePicker' }"
      >
        <span :style="item.styleSpan" class="search-span">{{ item.title }}</span>
        <EleTemplate
          :form-item="item"
          :form-key="key"
          :form.sync="form"
          :remote-method="handleremoteMethod"
        />
      </li>
    </ul>
    <div style="display: flex; justify-content: center; margin-top: 16px">
      <el-button icon="el-icon-refresh-right" @click="handleClear">重置</el-button>
      <el-button
        icon="el-icon-search"
        type="primary"
        :disabled="searchDisabledStatus"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
  </div>
</template>

<script>
  import EleTemplate from "@/components/EleTemplate";

  export default {
    name: "TapSearch",
    components: {
      EleTemplate,
    },
    props: {
      searchList: {
        type: Object,
        default: () => [],
      },
      form: {
        type: Object,
        default: () => {},
      },
      searchForm: {
        type: Function,
        default: null,
      },
      resetForm: {
        type: Function,
        default: null,
      },
      searchDisabledStatus: {
        type: Boolean,
        default: false,
      },
      remoteMethod: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {};
    },
    mounted() {
      this.searControl();
    },
    methods: {
      handleFilter() {
        this.searchForm();
      },
      handleClear() {
        this.resetForm();
      },
      handleremoteMethod(val) {
        this.remoteMethod(val);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tap_search {
    margin-bottom: 16px;
  border: 1px solid #ebeef5;
  padding: 10px 16px;
    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-left: -32px;

      .DateTimePicker {
        // width: 100%;
        min-width: 520px;
      }
      li {
        width: 16%;
        display: flex;
        min-width: 250px;
        align-items: center;
        padding-left: 15px;
        margin-bottom: 15px;

        span {
          min-width: 100px;
          text-align: right;
          padding-right: 5px;
        }
      }
    }

    .submit {
      // float: right;
      align-self: center;
    }
  }
  .search-span {
    width: 120px;
    line-height: 32px;
    font-weight: 400;
    color: #606266;
    font-size: 14px;
  }
</style>
